




































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { Treenode } from "@/definitions/treenode"

import GroupLayerView from "./groupLayerView/groupLayerView.vue"
import SingleLayerView from "./singleLayerView/singleLayerView.vue"
import  TopLine from "./topLine/topLine.vue"

@Component({
  components: {
      SingleLayerView,
    GroupLayerView,
    TopLine
  }
})
export default class LayerView extends Vue {

  @Prop()
  private treeNode!: Treenode;
  @Prop()
  private isGrabbing!: boolean;
  @Prop()
  private renameId!: number;

  get nodeStyle(){
      return {
          "padding-left" : 8 * this.treeNode.data.hierarchy + "px"
      }
  }

  toggle(){
    this.$emit("toggle" , this.treeNode)
  }

  editTitle(node) {
      this.$emit("editTitle", node)
  }

  decideTitle(node  , title){
    this.$emit("decideTitle" , node , title)
  }

  selectSingleNode(node){
      this.$emit("selectSingleNode" , node)
  }

  selectMultipleNodes(node){
      this.$emit("selectMultipleNodes" , node)
  }

  onClickRight(node , event){
      this.$emit("onClickRight" , node , event)
  }

  onGrabNode(treeNode , event){
      this.$emit("onGrabNode" , treeNode , event)
  }

  onDropObjectTree(position , event){
      this.$emit("onDropObjectTree" , position, event)
  }

}
